import styles from './index.module.scss';

const MeetingIcon: React.FC = () => {
    return <div className={styles.gif}></div>;
    // return (
    //     <div className={styles.box}>
    //         <span className={styles.item}></span>
    //         <span className={styles.item}></span>
    //         <span className={styles.item}></span>
    //     </div>
    // );
};

export default MeetingIcon;
